import { HttpErrorResponse } from '@angular/common/http';

import { ErrorResponse, ErrorResponseDetail } from '#types/core';

export function errorDetailBlob(response: HttpErrorResponse): Promise<ErrorResponseDetail> {
  return response.error
    .text()
    .then((data) => (JSON.parse(data) as ErrorResponse).error)
    .catch((err) => console.error(err));
}
